/* Maison Nuage — animations (progressive enhancement, no dependencies) */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function splitWords(el) {
    if (el.dataset.mnSplitDone) return;
    el.dataset.mnSplitDone = '1';
    var nodes = Array.prototype.slice.call(el.childNodes);
    var i = 0;
    var frag = document.createDocumentFragment();
    nodes.forEach(function (node) {
      if (node.nodeType === 3) {
        node.textContent.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
          var w = document.createElement('span'); w.className = 'mn-word';
          var s = document.createElement('span'); s.style.setProperty('--i', i++); s.textContent = part;
          w.appendChild(s); frag.appendChild(w);
        });
      } else if (node.nodeType === 1) {
        var w2 = document.createElement('span'); w2.className = 'mn-word';
        var s2 = document.createElement('span'); s2.style.setProperty('--i', i++);
        s2.appendChild(node.cloneNode(true)); w2.appendChild(s2); frag.appendChild(w2);
      }
    });
    el.innerHTML = ''; el.appendChild(frag);
  }

  function animateCounter(el) {
    var target = parseFloat(el.dataset.mnCount || '0');
    var suffix = el.dataset.mnSuffix || '';
    var dur = 1600, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      var val = target * eased;
      el.textContent = (Number.isInteger(target) ? Math.round(val) : val.toFixed(1)) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function init() {
    if (reduced) {
      document.querySelectorAll('[data-mn-reveal],.mn-split').forEach(function (e) { e.classList.add('mn-in'); });
      document.querySelectorAll('[data-mn-count]').forEach(function (e) { e.textContent = e.dataset.mnCount + (e.dataset.mnSuffix || ''); });
      return;
    }
    document.querySelectorAll('.mn-split').forEach(splitWords);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('mn-in');
        en.target.querySelectorAll('[data-mn-count]').forEach(animateCounter);
        if (en.target.dataset.mnCount) animateCounter(en.target);
        io.unobserve(en.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('[data-mn-reveal],.mn-split,[data-mn-count]').forEach(function (el) { io.observe(el); });

    /* stagger children */
    document.querySelectorAll('[data-mn-stagger]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.style.setProperty('--mn-delay', (i * 110) + 'ms');
      });
    });

    /* stars */
    document.querySelectorAll('.mn-sky[data-stars]').forEach(function (sky) {
      var n = parseInt(sky.dataset.stars, 10) || 60;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var s = document.createElement('i'); s.className = 'mn-star';
        s.style.left = Math.random() * 100 + '%';
        s.style.top = Math.random() * 100 + '%';
        var size = Math.random() * 2 + 1; s.style.width = s.style.height = size + 'px';
        s.style.setProperty('--d', (3 + Math.random() * 5) + 's');
        s.style.setProperty('--dl', (-Math.random() * 6) + 's');
        s.style.setProperty('--o', (0.4 + Math.random() * 0.6).toFixed(2));
        frag.appendChild(s);
      }
      sky.appendChild(frag);
    });

    /* parallax on hero */
    var hero = document.querySelector('.mn-hero');
    if (hero) {
      var moon = hero.querySelector('.mn-moon');
      var visual = hero.querySelector('.mn-hero__visual');
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          if (moon) moon.style.translate = '0 ' + (y * 0.18) + 'px';
          if (visual) visual.style.translate = '0 ' + (y * 0.08) + 'px';
          ticking = false;
        });
      }, { passive: true });
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        var dx = (e.clientX - r.left) / r.width - 0.5, dy = (e.clientY - r.top) / r.height - 0.5;
        var card = hero.querySelector('.mn-orb__card');
        if (card) card.style.transform = 'rotateY(' + (dx * 10) + 'deg) rotateX(' + (-dy * 10) + 'deg)';
      });
    }

    /* cursor glow */
    if (window.matchMedia('(hover:hover)').matches) {
      var glow = document.createElement('div'); glow.className = 'mn-cursor'; document.body.appendChild(glow);
      var gx = 0, gy = 0, tx = 0, ty = 0;
      window.addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; document.body.classList.add('mn-cursor-on'); }, { passive: true });
      (function loop() { gx += (tx - gx) * 0.12; gy += (ty - gy) * 0.12; glow.style.transform = 'translate(' + (gx - 170) + 'px,' + (gy - 170) + 'px)'; requestAnimationFrame(loop); })();
    }

    /* 3D tilt on product cards */
    document.querySelectorAll('.mn-product').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var dx = (e.clientX - r.left) / r.width - 0.5, dy = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'translateY(-8px) rotateY(' + (dx * 6) + 'deg) rotateX(' + (-dy * 6) + 'deg)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  /* re-run after view transitions / section rendering */
  document.addEventListener('page:loaded', init);
})();
